import { render, staticRenderFns } from "./travaux-restants.vue?vue&type=template&id=480ca582&scoped=true"
import script from "./travaux-restants.vue?vue&type=script&lang=ts"
export * from "./travaux-restants.vue?vue&type=script&lang=ts"
import style0 from "./travaux-restants.vue?vue&type=style&index=0&id=480ca582&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480ca582",
  null
  
)

export default component.exports